//@flow
import React from "react";
import {Popover, Row, Col, Collapse} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";

import placeholder from "../../../public/images/person-placeholder.jpg";
import {MarkerContainer, MarkerIcon, BulletText, CourierImg} from "./markerStyles";
import {MarkerPropType} from "./markerPropTypes";
import config from "../../../_core/config";
import {courierTypes, deliveryStatuses, mapCourierStatuses} from "../../../constants/constants";
import {
    formatPhoneNumber,
    constantFind,
    isConstantExist,
    getConstant
} from "../../../utils/helpers";
import {useStore} from "../../../hooks/useStore";

export const ReceiverMarker = ({
    lat,
    lng,
    icon,
    color,
    allOrdersOfDelivery,
    courierStatus,
    delivery,
    order
}: MarkerPropType) => {
    const stores = useStore();
    const history = useHistory();
    const {t} = useTranslation([
        "courierTypes",
        "courierStatuses",
        "mapCourierStatuses",
        "deliveryStatuses"
    ]);

    return (
        <MarkerContainer lat={lat} lng={lng} color={color} data-testid="map_receiverMarker">
            <Popover
                content={
                    <Collapse defaultActiveKey={[1]} bordered={false}>
                        <Collapse.Panel
                            header={t("fields.order", {ns: "common"})}
                            key="1"
                            extra={
                                stores.meStore.checkRole("orderDetail") && (
                                    <InfoCircleOutlined
                                        onClick={() => history.push("/orders/" + delivery._id)}
                                    />
                                )
                            }
                        >
                            <div>
                                {isConstantExist(deliveryStatuses, delivery?.deliveryState)
                                    ? t(
                                          `${
                                              getConstant(deliveryStatuses, delivery?.deliveryState)
                                                  .translation_key
                                          }.name`,
                                          {
                                              ns: "deliveryStatuses"
                                          }
                                      )
                                    : "-"}
                            </div>
                            {allOrdersOfDelivery.map((orderItem, i) => (
                                <BulletText
                                    key={i}
                                    color={
                                        !orderItem.stepInfo.canceled
                                            ? orderItem.stepIndex < delivery?.currentStepIndex &&
                                              "green"
                                            : orderItem.stepIndex < delivery?.currentStepIndex &&
                                              "red"
                                    }
                                    thick={orderItem._id === order._id}
                                >
                                    {`${orderItem.stepInfo.receiverName}, ${formatPhoneNumber(
                                        orderItem.stepInfo.receiverPhone
                                    )}`}
                                </BulletText>
                            ))}
                        </Collapse.Panel>
                        {delivery?.assignedCourier && (
                            <Collapse.Panel
                                header={delivery?.assignedCourier?.fullname}
                                key="2"
                                extra={
                                    stores.meStore.checkRole("courierDetail") && (
                                        <InfoCircleOutlined
                                            onClick={() =>
                                                history.push(
                                                    "/couriers/" + delivery.assignedCourier._id
                                                )
                                            }
                                        />
                                    )
                                }
                            >
                                <Row gutter={10}>
                                    <Col>
                                        <CourierImg
                                            src={
                                                delivery?.assignedCourier?.photo
                                                    ? `${config.getBasePublicUrl()}api/panel/v1/image/${
                                                          delivery?.assignedCourier.photo
                                                      }`
                                                    : placeholder
                                            }
                                        />
                                    </Col>
                                    <Col>
                                        <BulletText>
                                            {formatPhoneNumber(
                                                delivery?.assignedCourier?.cellPhone
                                            )}
                                        </BulletText>
                                        <BulletText>{delivery?.assignedCourier?.email}</BulletText>
                                        <BulletText>
                                            {isConstantExist(
                                                courierTypes,
                                                delivery?.assignedCourier?.type
                                            )
                                                ? t(
                                                      getConstant(
                                                          courierTypes,
                                                          delivery?.assignedCourier.type
                                                      ).translation_key,
                                                      {
                                                          ns: "courierTypes"
                                                      }
                                                  )
                                                : "-"}
                                        </BulletText>
                                        <BulletText>
                                            {isConstantExist(
                                                mapCourierStatuses,
                                                delivery?.deliveryState || courierStatus
                                            )
                                                ? t(
                                                      getConstant(
                                                          mapCourierStatuses,
                                                          delivery?.deliveryState || courierStatus
                                                      ).translation_key,
                                                      {
                                                          ns: "mapCourierStatuses"
                                                      }
                                                  )
                                                : "-"}
                                        </BulletText>
                                    </Col>
                                </Row>
                            </Collapse.Panel>
                        )}

                        <Collapse.Panel
                            header={t("fields.pickupLocations", {ns: "common"})}
                            key="3"
                        >
                            {delivery?.pickupInfos
                                ?.sort((prev, curr) => prev.index - curr.index)
                                ?.map((pickup, i) => (
                                    <React.Fragment key={i}>
                                        <BulletText>
                                            {pickup.name}, {formatPhoneNumber(pickup.phone)}
                                        </BulletText>
                                        <BulletText alter>{pickup.address}</BulletText>
                                    </React.Fragment>
                                ))}
                        </Collapse.Panel>
                    </Collapse>
                }
                trigger="click"
            >
                <MarkerIcon icon={icon} color={color} />
            </Popover>
        </MarkerContainer>
    );
};
